<!--
 * @Author: your name
 * @Date: 2020-07-24 15:26:59
 * @LastEditTime: 2021-04-01 15:11:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\pages\app-engine\app-engine-list\app-engine-list.vue
-->
<template>
  <div class="app-engine-list">
    <div class="search-bar">
      <x-input-search @search="doSearch"></x-input-search>
      <div class="menu-star" @click="handleCollect">
        <x-svg-icon v-if="!isCollect" name="star-icon"></x-svg-icon>
        <x-svg-icon v-else name="star-active-icon"></x-svg-icon>
      </div>
      <div v-if="showDataTemplate" class="data-template">
        <x-svg-icon name="data-template" @click.native="handleToggle"></x-svg-icon>
        <df-collapse-transition>
          <x-loading
            v-if="isShowDataTemplate"
            v-click-outside="onClickOutside"
            class="data-template-loading"
            :visible="dataTemplateLoading"
          >
            <div class="data-template-content">
              <template v-for="item in formDataTemplateList">
                <div
                  :key="item.id"
                  class="data-template-content-item"
                  @click="handleDataTemplateClick(item)"
                >
                  <span>{{ item.dataModuleName }}</span>
                </div>
              </template>
            </div>
          </x-loading>
        </df-collapse-transition>
        <div v-if="isShowDataTemplate" class="data-template-mask"></div>
      </div>
      <div v-if="formTabs.length > 1" class="tab-switch">
        <x-svg-icon name="tab-switch" @click.native="handleTabToggle"></x-svg-icon>
        <df-collapse-transition>
          <div v-if="isShowTabDropDown" v-click-outside="onClickOutside" class="tab-drop">
            <div class="data-template-content">
              <template v-for="item in formTabs">
                <div
                  :key="item.tabId"
                  :class="{'data-template-content-item': true, 'is-active': item.tabId === activeFormTab}"
                  @click="handleTabClick(item)"
                >
                  <span>{{ item.tabName }}</span>
                </div>
              </template>
            </div>
          </div>
        </df-collapse-transition>
        <div v-if="isShowTabDropDown" class="data-template-mask"></div>
      </div>
    </div>
    <list
      ref="list"
      rowKey="documentId"
      :columns="columns"
      :listData="listPageData"
      :showEmpty="showEmpty"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp"
      @click-item="handleClickItem"
    ></list>
    <div
      v-if="btnList.filter((btn) => btn.buttonCode === 'ADD').length > 0"
      class="list-add-icon active-style"
      @click="handleCreate"
    >
      <x-svg-icon name="add"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import List from '@/components/list/list.vue'
import apis from '@/api'
import PageButtonTypeMap from './page-button-type'
import MenuStarMixin from '@/mixin/menu-star.mixin.js'
import DfCollapseTransition from '@/transitions/collapse-transition/collapse-transition'
import { mapState } from 'vuex'

export default {
  components: {
    List,
    DfCollapseTransition
  },
  mixins: [MenuStarMixin],
  data() {
    return {
      formId: '',
      listPageConfig: {
        listPage: {
          queryConditions: [],
          queryLists: [],
          tileFormComponent: []
        },
        listPageViews: [
          {
            queryConditions: [],
            queryLists: [],
            tileFormComponent: []
          }
        ]
      },
      listPageData: [],
      btnList: [],
      tableConfig: {
        loading: false,
        pagination: {
          currentPage: 1,
          pageSize: 10,
          total: 0
        }
      },
      cubeScrollOptions: {
        // preventDefault: false,
        pullDownRefresh: {
          txt: '刷新成功'
        },
        pullUpLoad: {
          txt: {
            more: '上滑加载更多',
            noMore: '没有更多数据了'
          }
        },
        scrollbar: false
      },
      mobileKeyWord: '',
      // 数据模板相关
      isShowDataTemplate: false,
      isShowTabDropDown: false,
      dataTemplateLoading: false,
      formDataTemplateList: [],
      dataTemplateNum: 0,
      businessComponentsUuid: [],
      documentIdList: [],
      activeFormTab: '',
      currentFormTab: '',
      formTabs: []
      // columns: []
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo
    }),
    showEmpty: function() {
      return (!this.listPageData || this.listPageData.length === 0) && !this.tableConfig.loading
    },
    columns() {
      // return this.listPageConfig.listPage.queryLists.map((item) => {
      //   return this.listPageConfig.listPage.tileFormComponent.find(
      //     (_item) => _item.uuid === item.uuid
      //   )
      // })
      // if (this.listPageConfig.listPageViews[0].queryLists.length === 0) {
      //   return this.listPageConfig.listPageViews[0].tileFormComponent
      // } else {
      //   let queryLisits = this.listPageConfig.listPageViews[0].queryLists.slice(0, 4)
      //   let tileFormComponent = this.listPageConfig.listPageViews[0].tileFormComponent
      //   for (let i = 0; i < queryLisits.length; i++) {
      //     for (let j = 0; j < tileFormComponent.length; j++) {
      //       if (queryLisits[i].uuid === tileFormComponent[j].uuid) {
      //         queryLisits[i].moneyDisplayStyle = tileFormComponent[j].moneyDisplayStyle
      //       }
      //     }
      //   }
      //   return queryLisits
      // }
      // return this.listPageConfig.listPageViews[0].queryLists.map((item) => {
      //   return this.listPageConfig.listPageViews[0].tileFormComponent.find(
      //     (_item) => _item.uuid === item.uuid
      //   )
      // })
      if (this.listPageConfig.listPageViews[0].queryLists.length === 0) {
        return this.listPageConfig.listPageViews[0].tileFormComponent
      } else {
        return this.listPageConfig.mobileListPageView
          ? this.listPageConfig.mobileListPageView.queryLists
          : this.listPageConfig.listPageViews[0].queryLists.slice(0, 4)
      }
    },
    showDataTemplate() {
      return (
        this.btnList.filter((btn) => btn.buttonCode === 'DATA_TEMPLATE').length > 0 &&
        this.dataTemplateNum > 0
      )
    }
  },
  created() {
    this.formId = this.$route.query.formId
    // 请求所有tab页
    this.queryAllTabs(this.formId)
    // this.queryListConfigByFormId(this.formId)
    // this.queryListPageButton(this.formId)
    // this.queryDataTemplateCount(this.formId)
  },
  methods: {
    queryAllTabs(formId) {
      this.$nextTick(() => {
        this.tableConfig.loading = true
        this.$loading.show()
      })
      const request = {
        ...apis.APP_PAGE.QUERY_FORM_TABS,
        params: {
          formId: formId
        }
      }
      this.$request(request).asyncThen((resp) => {
        if (resp.code === 'ok') {
          this.formTabs = resp.data
          if (this.formTabs.length > 0) {
            this.activeFormTab = this.formTabs[0].tabId
            this.currentFormTab = this.formTabs[0].tabId
            this.getFormDataByTabId(this.activeFormTab)
          } else {
            this.$loading.hide()
            this.tableConfig.loading = false
            throw new Error('视图页配置为空')
          }
        }
      }, (err) => {
        this.tableConfig.loading = false
        this.$loading.hide()
        console.error(err)
      }).asyncErrorCatch((err) => {
        this.tableConfig.loading = false
        this.$loading.hide()
        console.error(err)
      })
    },
    getFormDataByTabId(tabId) {
      this.$loading.show()
      this.activeFormTab = tabId
      this.queryListConfigByFormId(this.formId, tabId)
      this.queryListPageButton(this.formId)
      this.queryDataTemplateCount(this.formId)
    },
    queryListConfigByFormId(formId, tabId) {
      const request = { ...apis.APP_PAGE.QUERY_LIST_PAGE_CONFIG_BY_ID }
      request.params = {
        formId,
        tabId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.businessComponentsUuid = []
            // if (resp.data.listPageViews[0]) {
            //   resp.data.listPageViews[0].queryLists.forEach((item) => {
            //     if (item.componentType === 'FORM_DATA_STATISTICS') {
            //       this.businessComponentsUuid.push(item.uuid)
            //     }
            //   })
            // }
            if (resp.data.listPageViews[0]) {
              // 如果有mobile的配置且mobile配置中的queryLists有长度则使用mobile的querylists
              if (
                resp.data.listPageViews[0].mobileListPageView &&
                resp.data.listPageViews[0].mobileListPageView.queryLists &&
                resp.data.listPageViews[0].mobileListPageView.queryLists.length > 0
              ) {
                this.listPageConfig.mobileListPageView = this.$lodash.cloneDeep(
                  resp.data.listPageViews[0].mobileListPageView
                )
                this.listPageConfig.mobileListPageView.queryLists = resp.data.listPageViews[0].mobileListPageView.queryLists.filter(
                  (item) => item.displayFlag
                )
                // 如果移动端列表配置组件全隐藏则默认取四个显示
                if (this.listPageConfig.mobileListPageView.queryLists.length === 0) {
                  this.listPageConfig.mobileListPageView.queryLists = resp.data.listPageViews[0].mobileListPageView.queryLists.slice(0, 4)
                }
                this.listPageConfig.mobileListPageView.queryLists.forEach((item) => {
                  if (item.componentType === 'FORM_DATA_STATISTICS') {
                    this.businessComponentsUuid.push(item.uuid)
                  }
                })
              } else {
                if (resp.data.listPageViews[0].queryLists.length > 0) {
                  // 如果是包含了displayFlag字段的queryLists则说明用户已经修改过则需要过滤出dispalyFlag为true的
                  if (resp.data.listPageViews[0].queryLists[0].hasOwnProperty('displayFlag')) {
                    resp.data.listPageViews[0].queryLists
                      .filter((item) => item.displayFlag)
                      .forEach((item) => {
                        if (item.componentType === 'FORM_DATA_STATISTICS') {
                          this.businessComponentsUuid.push(item.uuid)
                        }
                      })
                  } else {
                    resp.data.listPageViews[0].queryLists.forEach((item) => {
                      if (item.componentType === 'FORM_DATA_STATISTICS') {
                        this.businessComponentsUuid.push(item.uuid)
                      }
                    })
                  }
                }
              }
            }
            Object.assign(this.listPageConfig, resp.data)
            // 获取表格数据
            this.queryTableData(
              formId,
              this.tableConfig.pagination.currentPage,
              this.tableConfig.pagination.pageSize,
              this.mobileKeyWord,
              tabId
            )
          },
          (err) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.tableConfig.loading = false
          this.$loading.hide()
          console.error(err)
        })
    },
    queryTableData(formId, page, pageSize, mobileKeyWord, tabId) {
      // if (
      //   !this.listPageConfig.listPage.queryLists ||
      //   this.listPageConfig.listPage.queryLists.length === 0
      // ) {
      //   this.tableConfig.loading = false
      //   this.$loading.hide()
      //   this.listPageData = []
      //   return
      // }
      const request = { ...apis.APP_PAGE.QUERY_LIST_BUSINESS_DATA }
      request.params = {
        formId: formId,
        page: page,
        pageSize: pageSize,
        mobileKeyWord: mobileKeyWord,
        tabId: tabId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.documentIdList = resp.table.map((item) => {
              return item.documentId
            })
            const requsetStatistics = { ...apis.COMPONENT.QUERY_STATISTICS_VALUE_COLUME }
            this.businessComponentsUuid.forEach((item) => {
              requsetStatistics.params = {
                uuid: item,
                formId: formId,
                documentIdList: this.documentIdList
              }
              this.$request(requsetStatistics).asyncThen((response) => {
                this.listPageData.forEach((item) => {
                  let value = response.data.data[item.documentId]
                  let key = response.data.uuid
                  if (value) {
                    item[key] = value
                  }
                })
                this.listPageData = this.$lodash.cloneDeep(this.listPageData)
              })
            })
            this.tableConfig.loading = false
            this.$loading.hide()
            if (request.params.page === 1) {
              this.listPageData = []
            }
            if (!resp.table || resp.table.length === 0) {
              this.$refs.list.forceUpdate()
            } else {
              this.listPageData = this.listPageData.concat(resp.table || [])
              this.tableConfig.pagination.currentPage = page
              this.tableConfig.pagination.pageSize = pageSize
              this.tableConfig.pagination.total = resp.total
              if (this.listPageData.length === resp.total) {
                this.$refs.list.forceUpdate()
              }
            }
          },
          (err) => {
            this.tableConfig.loading = false
            this.$loading.hide()
            this.$refs.list.forceUpdate()
            console.error(err)
          }
        )
        .asyncErrorCatch((err) => {
          this.tableConfig.loading = false
          this.$loading.hide()
          this.$refs.list.forceUpdate()
          console.error(err)
        })
    },
    queryListPageButton(formId) {
      const request = { ...apis.APP_PAGE.QUERY_LIST_PAGE_BUTTON }
      request.params = {
        formId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            const btnList = resp.data
            btnList.forEach((btn) => {
              btn.icon = PageButtonTypeMap[btn.buttonCode] && PageButtonTypeMap[btn.buttonCode].icon
              btn.executeFunction =
                PageButtonTypeMap[btn.buttonCode] &&
                PageButtonTypeMap[btn.buttonCode].executeFunction
            })
            this.btnList = btnList
          },
          (error) => {
            console.error(error)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
        })
    },
    onPullingDown(e) {
      this.tableConfig.pagination.currentPage = 1
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord,
        this.currentFormTab
      )
    },
    onPullingUp(e) {
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage + 1,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord,
        this.currentFormTab
      )
    },
    doSearch(e) {
      this.$loading.show()
      this.mobileKeyWord = e
      this.tableConfig.pagination.currentPage = 1
      this.queryTableData(
        this.formId,
        this.tableConfig.pagination.currentPage,
        this.tableConfig.pagination.pageSize,
        this.mobileKeyWord,
        this.currentFormTab
      )
    },
    handleCreate() {
      this.$router.push({
        name: 'form',
        query: {
          title: this.$route.query.title,
          formId: this.formId,
          appId: this.$route.query.appId,
          processId: this.$route.query.processId,
          menuId: this.$route.query.currentMenu || this.$route.query.menuId
        }
      })
    },
    handleClickItem(item) {
      this.$router.push({
        name: 'form',
        query: {
          title: this.$route.query.title,
          formId: this.formId,
          documentId: item.documentId,
          taskId: item.taskId,
          processId: this.$route.query.processId,
          appId: this.$route.query.appId,
          menuId: this.$route.query.currentMenu || this.$route.query.menuId,
          tabId: this.activeFormTab
        }
      })
    },
    handleToggle() {
      this.isShowDataTemplate = !this.isShowDataTemplate
      if (this.isShowDataTemplate) {
        this.queryDataTemplateList()
      }
    },
    handleTabToggle() {
      this.isShowTabDropDown = !this.isShowTabDropDown
    },
    handleDataTemplateClick(item) {
      this.$router.push({
        name: 'form',
        query: {
          title: this.$route.query.title,
          formId: this.formId,
          appId: this.$route.query.appId,
          processId: this.$route.query.processId,
          menuId: this.$route.query.currentMenu || this.$route.query.menuId,
          dataTemplateId: item.id
        }
      })
    },
    handleTabClick(tabItem) {
      this.isShowTabDropDown = false
      this.getFormDataByTabId(tabItem.tabId)
    },
    queryDataTemplateList() {
      const request = { ...apis.APP_PAGE.QUERY_DATA_TEMPLATE_LIST }
      request.params = {
        formId: this.formId,
        moduleOwner: this.userInfo && this.userInfo.id
      }
      this.dataTemplateLoading = true
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.formDataTemplateList = resp.data
            this.dataTemplateLoading = false
          },
          (error) => {
            this.dataTemplateLoading = false
            console.log(error)
          }
        )
        .asyncErrorCatch((error) => {
          this.dataTemplateLoading = false
          console.error(error)
        })
    },
    queryDataTemplateCount(formId) {
      const request = { ...apis.APP_PAGE.QUERY_DATA_TEMPLATE_COUNT }
      request.params = {
        formId
      }
      this.$request(request)
        .asyncThen(
          (resp) => {
            this.dataTemplateNum = resp.data
          },
          (error) => {
            console.log(error)
          }
        )
        .asyncErrorCatch((error) => {
          console.error(error)
        })
    },
    onClickOutside(e) {
      e.preventDefault()
      e.stopPropagation()
      this.isShowDataTemplate = false
      this.isShowTabDropDown = false
    }
  }
}
</script>

<style lang="scss">
.app-engine-list {
  width: 100%;
  height: 100%;
  .search-bar {
    display: flex;
    align-items: center;
    padding: 0 1.14rem;
    .x-input-search {
      flex: 1;
      padding: 0.71rem 0;
    }
    .menu-star {
      flex: 0 0 2rem;
      display: flex;
      justify-content: flex-end;
    }
    .data-template {
      position: relative;
      z-index: 100;
      .data-template-loading {
        position: absolute;
        top: 2.143rem;
        right: 0;
        width: 7rem;
        border-radius: $--app-base-border-radius;
        background-color: $--app-box-bgColor;
        z-index: 100;
        box-shadow: $--app-box-shadow;
        box-sizing: border-box;
        max-height: 50vh;
        overflow: auto;
        padding: 0.357rem 0;
        > img {
          width: 7rem;
        }
        .data-template-content {
          display: flex;
          flex-direction: column;
          .data-template-content-item {
            flex: 1;
            display: flex;
            align-items: center;
            height: 2.29rem;
            min-height: 2.29rem;
            > span {
              font-size: $--app-base-font-size;
              flex: 1;
              color: $--app-primary-color;
              margin: 0 1rem;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
        }
      }
      .data-template-mask {
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
      }
    }
    .tab-switch {
      position: relative;
      z-index: 100;
      .tab-drop {
        position: absolute;
        top: 2.143rem;
        right: 0;
        width: 7rem;
        border-radius: $--app-base-border-radius;
        background-color: $--app-box-bgColor;
        z-index: 100;
        box-shadow: $--app-box-shadow;
        box-sizing: border-box;
        max-height: 50vh;
        overflow: auto;
        padding: 0.357rem 0;
        .data-template-content {
          display: flex;
          flex-direction: column;
          .data-template-content-item {
            flex: 1;
            display: flex;
            align-items: center;
            height: 2.29rem;
            min-height: 2.29rem;
            > span {
              font-size: $--app-base-font-size;
              flex: 1;
              color: $--app-base-font-color;
              margin: 0 1rem;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }
          }
          .is-active {
            > span {
              color: $--app-primary-color !important;
            }
          }
        }
      }
      .data-template-mask {
        position: fixed;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        left: 0;
        top: 0;
      }
    }
  }
  .list {
    width: 100%;
    height: calc(100% - 3.7rem);
    overflow: hidden;
    padding: 0.57rem 1.14rem;
    background-color: $--app-body-bgColor;
    box-sizing: border-box;
    .list-card {
      margin-bottom: 0.57rem;
    }
  }
  .list-add-icon {
    width: 2.857rem;
    height: 2.857rem;
    position: absolute;
    right: 1.071rem;
    bottom: 5.3%;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: $--app-light-color;
    background-color: $--app-primary-color;
    .x-svg-icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
